import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, watch, ref } from "vue";
import { FormInput, Checkbox, Submit } from "@/ts/components/form";
import { useForm } from "vee-validate";
import * as Yup from "yup";
import { useErrors } from "@/ts/utils/api-functions";
import { trans, wTrans, isLoaded } from "laravel-vue-i18n";
import { useReCaptcha } from "vue-recaptcha-v3";
import { MembershipData } from "@/ts/components/members";
import axios from "axios";
import { serialize } from "object-to-formdata";

interface Props {
    data: MembershipData["personal_info"];
    showBack?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    data: { type: null, required: true },
    showBack: { type: Boolean, required: false }
  },
  emits: ["submit", "back", "mounted"],
  setup(__props: any, { expose, emit }) {
  expose();

const props = __props as {
    data: MembershipData["personal_info"];
    showBack?: boolean;
}

const apiErrors = useErrors();
const reCaptcha = useReCaptcha();
const success = ref(false);
const loading = ref(false);
const mounted = ref(false);
const component = ref<HTMLDivElement>();




const schema = computed(() =>
    Yup.object({
        first_name: Yup.string().required().label(wTrans("membership.personal_info.first_name").value),
        last_name: Yup.string().required().label(wTrans("membership.personal_info.last_name").value),
        email: Yup.string().email().required().label(wTrans("membership.personal_info.email").value),
        phone: Yup.string()
            .matches(/(((\+|00)3[12][ ]?(?:\(0\)[ ]?)?)|0){1}(4(60|[789]\d)\/?(\s?\d{2}\.?){2}(\s?\d{2})|(\d\/?\s?\d{3}|\d{2}\/?\s?\d{2})(\.?\s?\d{2}){2})/, "Telefoonnummer is ongeldig")
            .required()
            .label(wTrans("membership.personal_info.phone").value),
        street: Yup.string().required().label(wTrans("membership.personal_info.street").value),
        number: Yup.string().required().label(wTrans("membership.personal_info.number").value),
        addition: Yup.string().optional().label(wTrans("membership.personal_info.addition").value),
        postal_code: Yup.string()
            .matches(/^[1-9]{1}[0-9]{3}$/, "Postcode is ongeldig")
            .required()
            .label(wTrans("membership.personal_info.postal_code").value),
        city: Yup.string().required().label(wTrans("membership.personal_info.city").value),
        birth_date: Yup.string()
            .matches(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/, "Geboortedatum is ongeldig")
            .required()
            .label(wTrans("membership.personal_info.birth_date").value),
        privacy: Yup.bool().oneOf([true]),
    }),
);

const { handleSubmit, errors, meta, isSubmitting } = useForm({
    initialValues: props.data,
    validationSchema: schema,
});

const onSubmit = handleSubmit(async (values, { resetForm }) => {
    loading.value = true;
    try {
        await reCaptcha!.recaptchaLoaded();
        const token = await reCaptcha!.executeRecaptcha("login");
        const formData = serialize(values);
        formData.append("g-recaptcha-response", token);
        formData.append("_wpcf7_unit_tag", "9326487");
        await axios.post("/api/membership", formData);
        success.value = true;
        emit("submit", values);
    } catch (error) {
        apiErrors.parse(error);
    } finally {
        loading.value = false;
    }
});

onMounted(() => {
    let translationsChecker = setInterval(() => {
        if (isLoaded()) {
            mounted.value = true;
            emitComponentHeight();
            clearInterval(translationsChecker);
        }
    }, 50);

    window.addEventListener("resize", () => {
        emitComponentHeight();
    });

    window.addEventListener("orientationchange", () => {
        emitComponentHeight();
    });

    // scroll to top
    window.scrollTo(0, 0);
});

function emitComponentHeight() {
    if (component.value) {
        emit("mounted", component.value!.offsetHeight);
    }
}

watch(
    errors,
    async () => {
        setTimeout(() => {
            emitComponentHeight();
        }, 50);
    },
    { deep: true },
);

watch(
    meta,
    async () => {
        setTimeout(() => {
            emitComponentHeight();
        }, 50);
    },
    { deep: true },
);

const __returned__ = { apiErrors, reCaptcha, success, loading, mounted, component, props, emit, schema, handleSubmit, errors, meta, isSubmitting, onSubmit, emitComponentHeight, FormInput, Checkbox, Submit, trans }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})